import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from '../../../../ui/button';
import { ActivityType, DayIntervals } from '../../../../../model/activity.model';

// Helper to format time consistently
const formatTime = (date: Date) =>
  date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

interface EditingInterval {
  intervalId: string;
  originalStart: Date;
  originalEnd: Date;
  newStart: Date;
  newEnd: Date;
}

interface EditModeBarProps {
  editingInterval: EditingInterval;
  daysIntervals: DayIntervals[];
  activityTypesMap: Map<string, ActivityType>;
  onCancel: () => void;
  onSave: () => void;
  cancelLabel: string;
  saveLabel: string;
}

const EditModeBar: React.FC<EditModeBarProps> = ({
  editingInterval,
  daysIntervals,
  activityTypesMap,
  onCancel,
  onSave,
  cancelLabel,
  saveLabel,
}) => {
  // Find activity name for the editing interval
  let activityName = '';
  for (const dayInterval of daysIntervals) {
    const found = dayInterval.intervals.find(i => i.id === editingInterval.intervalId);
    if (found) {
      activityName = activityTypesMap.get(found.typeId)?.name || '';
      break;
    }
  }

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 mb-2 bg-muted border border-border rounded-lg">
      <div className="flex items-center gap-3">
        <span className="font-semibold">{activityName}</span>
        <span className="text-muted-foreground line-through">
          {formatTime(editingInterval.originalStart)} - {formatTime(editingInterval.originalEnd)}
        </span>
        <span className="text-primary font-semibold">
          → {formatTime(editingInterval.newStart)} - {formatTime(editingInterval.newEnd)}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onCancel}
        >
          <X className="h-4 w-4 mr-1" />
          {cancelLabel}
        </Button>
        <Button
          size="sm"
          onClick={onSave}
        >
          <Check className="h-4 w-4 mr-1" />
          {saveLabel}
        </Button>
      </div>
    </div>
  );
};

export default EditModeBar;
